// Analytics Color Palette and Constants
// Shared colors and configurations for analytics charts

export const COLORS = {
  primary: '#0d9488',
  secondary: '#0f172a',
  success: '#22c55e',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#3b82f6',
  grades: {
    A: '#22c55e',
    B: '#84cc16',
    C: '#f59e0b',
    D: '#f97316',
    F: '#ef4444'
  }
};

export const DATE_RANGE_OPTIONS = [
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 90 days' },
  { value: '180', label: 'Last 6 months' },
  { value: '365', label: 'Last year' }
];
